import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Flex } from '@mixins';
import { theme } from '@styles';
import { Icon } from '@atoms';
import { routes } from '@constants';

import { ReactComponent as Logo } from '@assets/svgs/Logo.svg';

const OnboardingHeader = () => {
  const history = useHistory();

  const handleHomeClick = useCallback(() => {
    history.push(routes.home);
  }, []);

  return (
    <Flex
      position="fixed"
      top={0}
      left={0}
      right={0}
      width="100%"
      flexDirection="column"
      backgroundColor={theme.color.white}
      zIndex={1000}>
      <Flex
        width="100%"
        alignItems="center"
        justifyContent="space-between"
        px={['20px', '30px', '40px', '60px']}
        py={['10px', '14px', '17px']}
        borderBottom="1px solid #e0e0e0">
        <Flex pointer onClick={handleHomeClick}>
          <Icon SVG={Logo} width={[100, 140]} height="auto" />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default OnboardingHeader;
